/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import { Menu } from '@mui/material';
import { Filter } from 'lucide-react';
import { STYLED_SELECT_CLASS, STYLED_SELECT_STYLE } from '../../../utils/styledSelect';

// Reusable DS filter popover for the Alerts tabs. `groups` is an array of
// { label, options: [{id, name}], value, onChange } rendered as DS selects.
function AlertFilterMenu({ groups, onReset, onSearch }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const close = () => setAnchorEl(null);

  return (
    <>
      <button
        type="button"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        className="inline-flex items-center gap-2 px-4 py-2 rounded-[8px] text-sm font-semibold text-white bg-brand-700 hover:bg-[#1a3156] transition flex-shrink-0"
      >
        <Filter size={16} />
        Filters
      </button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            mt: '8px',
            borderRadius: '12px',
            border: '1px solid #e0e1e6',
            boxShadow: '0 8px 24px rgba(14, 30, 64, 0.12)',
            width: 320,
            maxWidth: 'calc(100vw - 32px)',
          },
        }}
        sx={{ '& .MuiMenu-list': { padding: 0 } }}
      >
        <div style={{ padding: 24 }}>
          <h5 className="text-lg font-semibold text-ink-900 mb-4">Filters</h5>
          {groups.map((g) => (
            <div key={g.label} className="mb-4">
              <span className="block text-[11px] font-semibold uppercase tracking-wider text-ink-500 mb-1.5" style={{ letterSpacing: '0.05em' }}>
                {g.label}
              </span>
              <select
                value={g.value}
                onChange={(e) => g.onChange(e.target.value)}
                className={`${STYLED_SELECT_CLASS} w-full`}
                style={STYLED_SELECT_STYLE}
              >
                {g.options.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
              </select>
            </div>
          ))}
          <div className="flex justify-end items-center gap-4 mt-2">
            <button
              type="button"
              onClick={onReset}
              className="text-sm font-medium text-ink-900 hover:text-ink-700 bg-transparent border-0 cursor-pointer"
            >
              Reset
            </button>
            <button
              type="button"
              onClick={() => { onSearch(); close(); }}
              className="inline-flex items-center justify-center px-5 py-2 bg-[#53A551] text-white rounded-[8px] text-sm font-semibold hover:bg-[#458a44] transition"
            >
              Search
            </button>
          </div>
        </div>
      </Menu>
    </>
  );
}

export default AlertFilterMenu;
